import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Mousewheel, A11y } from 'swiper'
import { Chevron, gaEvent } from 'shared'

SwiperCore.use([Navigation, Pagination, Mousewheel, A11y])

export const BannerSwiper = ({ banners }) => {
  const showChevrons = banners.length > 2

  return (
    <div className='generic-teaser-swiper user-select-none'>
      {showChevrons && <Chevron id='banner-list-prev' direction='left' />}
      <Swiper
        spaceBetween={40}
        slidesPerView={1}
        pagination={banners.length > 1 ? { clickable: true } : false}
        navigation={{
          nextEl: `#banner-list-next`,
          prevEl: `#banner-list-prev`,
          disabledClass: 'is-disabled',
        }}
        roundLengths
        mousewheel={{ forceToAxis: true }}
        breakpoints={{
          450: {
            slidesPerView: 2,
          },
        }}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={banner.id}>
            <Banner index={index} {...banner} />
          </SwiperSlide>
        ))}
      </Swiper>
      {showChevrons && <Chevron id='banner-list-next' direction='right' />}
    </div>
  )
}

const Banner = (props) => {
  const handleClick = () => {
    gaEvent('navigation', `click banner_${props.clicktracking_name}`, `banner_position ${props.index + 1}`)
  }

  return <div className="item swiper-slide">
    <a onClick={handleClick} href={props.url}>
      <img alt={props.alt_text} src={props.picture_url} />
    </a>
  </div>
}
